import BusinessContractRouteList from './BusinessContractRouteList';
import BusinessContractRouteEdit from './BusinessContractRouteEdit';
import BusinessContractRouteCreate from './BusinessContractRouteCreate';

const businessContractRoutes = {
	list: BusinessContractRouteList,
	edit: BusinessContractRouteEdit,
	create: BusinessContractRouteCreate
};

export default businessContractRoutes;
